<template>
  <div>
    <div v-if="selectPeriods===null||selectPeriods===undefined||selectPeriods.length===0" style="margin: 10px">
      还没有任何健身房预约
    </div>
    <!--      绑定开始-->
    <div v-if="bindInfo.bindType!==undefined">
      <div v-if="bindInfo.bindType==='Student'">
        <el-tag type="success">已绑定学号姓名：{{ bindInfo.name }} {{ bindInfo.xh }}</el-tag>
        <br>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/CancelBind')">删除绑定</el-button>
      </div>
      <div v-if="bindInfo.bindType==='None'">
        <el-tag type="danger">未绑定学号姓名，无法选座</el-tag>
        <br>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/bindXh')">前往绑定（学生）</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/BindTeacher')">前往绑定（教职工）</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/TeacherExtendFrom')">从已认证的手机同步身份</el-button>
      </div>
      <div v-if="bindInfo.bindType==='TeacherVerified'">
        <el-tag type="success">已绑定且已认证：{{ bindInfo.name }} {{ bindInfo.affiliation }}</el-tag>
        <br>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/CancelBind')">删除绑定</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/TeacherExtendTo')">同步身份到另一台手机</el-button>
      </div>
      <div v-if="bindInfo.bindType==='TeacherUnverified'">
        <el-tag type="warning">已绑定但未认证：{{ bindInfo.name }} {{ bindInfo.affiliation }}</el-tag>
        <el-tag type="warning">请首次前往时携带工作证以备查验</el-tag>
        <br>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/CancelBind')">删除绑定</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/TeacherExtendTo')">同步身份到另一台手机</el-button>
        <el-button style="margin: 5px" type="mini" @click="$router.push('/VerifyTeacher')">认证</el-button>
      </div>

    </div>
    <el-tag style="margin: 20px" type="success" v-if="bindInfo.gymdefault==='0'||bindInfo.gymdefault===undefined||bindInfo.gymdefault==='即将上线'">
      违约次数：{{ bindInfo.gymdefault }}</el-tag>
    <el-tag style="margin: 20px" type="warning" v-if="bindInfo.gymdefault==='1'||bindInfo.gymdefault==='2'">
      违约次数：{{ bindInfo.gymdefault }}
    </el-tag>
    <el-tag style="margin: 20px" type="danger"
            v-if="bindInfo.gymdefault!=='0'&&bindInfo.gymdefault!=='1'&&bindInfo.gymdefault!=='2'&&bindInfo.gymdefault!==undefined&&bindInfo.gymdefault!=='即将上线'">
      违约次数：{{ bindInfo.gymdefault }}
    </el-tag>
    <el-button style="margin: 5px" type="mini" @click="$router.push('/ResetDefault')">显示验证码</el-button>
    <!--      绑定结束-->


    <el-card class="card" v-for="item of selectPeriods" shadow="hover">
      <div slot="header" class="clearfix">
        <span>健身房预约</span>

        <el-popover
            v-model="item.deleteMenuVisible">
          <p>确定取消该预约吗？</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="item.deleteMenuVisible = false">取消</el-button>
            <el-button type="primary" size="mini"
                       @click="item.deleteMenuVisible = false;doCancelGymReserve(item.uuid)">确定
            </el-button>
          </div>
          <el-button type="text" slot="reference" style="float: right; padding: 3px 0;"
                     @click="cancelGymReserveWindowOpen">取消预约
          </el-button>
        </el-popover>

      </div>

      <span>
      时间段：{{ item.Period + " " + parsePeriod(item.Period) }}
       </span>


    </el-card>

  </div>


</template>

<script>
import axios from '@/utils/request'
import {parseByKey} from "@/utils/roomsAdapter";
import {parsePeriod} from "@/utils/WeekParser";

export default {
  name: 'Home',
  data() {
    return {
      selectPeriods: [],
      bindInfo: {}
    }
  },
  methods: {
    parsePeriod(p) {
      return parsePeriod(p)
    },
    getBindInfo() {
      axios.post("/getBindInfo").then(res => {
        this.bindInfo = res.data.bindInfo
      })
    },
    getMySelection() {
      axios.post("/GetGymSelected", {key: this.$store.state.nowRoom.key}).then(res => {
        console.log(res);
        this.selectPeriods = res.data.data
      })
    },
    doCancelGymReserve(uuid) {
      axios.post("/LeaveGym", {uuid, key: this.$store.state.nowRoom.key}).then(res => {
        console.log(res);
        this.getMySelection()
      })


    },
    cancelGymReserveWindowOpen(item) {
      item.deleteMenuVisible = true
    }


  },
  mounted() {
    this.getBindInfo()
    this.getMySelection()
  },
  created() {
  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
